// src/components/home/HeroSection.jsx
import React, { useState, useEffect } from 'react';

// Hero images
import image1 from '../../assets/A_Image1.png';
import image2 from '../../assets/A_image2.png';
import image3 from '../../assets/A_Image3.png';
import healingImage from '../../assets/A-image16.png';
import testimonialsImage from '../../assets/A-image15.png';
import leaf1 from '../../assets/leaf1.png';           // ← Your original leaf (untouched)
import topLeftLeaf from '../../assets/leaf4.png';      // ← New independent leaf for top-left (same image, different name)
import '../../common/solox-btn.css';


const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    // … your existing slides (100% unchanged) …
    {
      id: 0,
      title: 'Where Comfort Meets',
      highlight: 'Healing Serenity',
      subtitle: 'Step into a peaceful sanctuary surrounded by nature. Our Ayurveda-inspired\naccommodations combine traditional charm with modern comfort – ensuring\nrelaxation from the moment you arrive.',
      buttonText: 'Explore More',
      type: 'composite',
      largeImage: image1,
      smallImageLeft: image2,
      smallImageRight: image3,
      leaves: [
        { src: leaf1, class: 'leaf-main bottom-right', style: { bottom: '-28%', right: '48%', transform: 'rotate(8deg)', width: '200px' } },
      ],
    },
    {
      id: 1,
      title: 'Healing Hands,',
      highlight: 'Heartfelt Care',
      subtitle: 'From warm welcomes to guided wellness routines, our dedicated team ensures\na nurturing experience rooted in ancient hospitality.',
      buttonText: 'Meet Our Team',
      type: 'single',
      image: healingImage,
      leaves: [
        { src: leaf1, class: 'leaf-accent top-right', style: { top: '20%', right: '8%', transform: 'rotate(10deg)', width: '140px', opacity: 0.7 } },
      ],
    },
    {
      id: 2,
      title: 'Trusted by Guests,',
      highlight: 'Celebrated for Care',
      subtitle: 'Thousands of guests have rediscovered peace and vitality with us. Their\nheartfelt stories reflect the harmony and trust that define the Ayusanjivni\nexperience.',
      buttonText: 'Read Testimonials',
      type: 'single',
      image: testimonialsImage,
      leaves: [],
    },
  ];

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => setCurrentSlide(index);
  const goToNextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const goToPrevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <section id="hero" className="bg-[#EBE0CF] px-4 sm:px-6 md:px-20 py-12 mt-0 sm:py-16 md:py-20 font-joan min-h-[70vh] sm:min-h-[80vh] relative overflow-hidden antialiased">

      {/* ─────────────────────── NEW TOP-LEFT LEAF (completely independent) ─────────────────────── */}
      <div className="absolute -top-4 -left-14 md:-top-8 md:-left-24 z-10 pointer-events-none"style={{ transform: 'rotate(40deg)' }}>
  <img
    src={topLeftLeaf}
    alt="Decorative ivy leaf"
    className="left-0 w-48 sm:w-56 md:w-64 lg:w-72 drop-shadow-2xl animate-float-gentle"
    style={{
      transform: 'rotate(0deg)',
      filter: 'brightness(1.05) saturate(1.2)',
    }}
  />
</div>


      {/* ───────────────────────────────────────────────────────────────────────────────────────────── */}

      <div className="max-w-7xl mx-auto w-full relative">
        {/* Slides Container */}
       <div className="hero-slides relative w-full min-h-[650px] sm:min-h-[600px]">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`absolute top-0 left-0 w-full h-full flex flex-col sm:flex-col md:flex-row items-center justify-between gap-4 sm:gap-2 xs:gap-0 md:gap-6 lg:gap-10 transition-all duration-700 ease-in-out ${
                index === currentSlide
                  ? 'opacity-100 translate-x-0 z-20'
                  : 'opacity-0 translate-x-full z-10'
              }`}
            >
              {/* Hero Text Content */}
              <div className="flex-1 max-w-2xl text-center md:text-left z-30 px-2 sm:px-4 md:px-0 order-2 md:order-1">
                <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-black-800 mb-4 sm:mb-6 leading-tight">
                  {slide.title}
                  <br />
                  <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-black-800 mt-1 sm:mt-2 block font-extrabold">
                    {slide.highlight}
                  </span>
                </h1>
                <p className="text-base sm:text-lg md:text-xl text-black-500 mb-6 sm:mb-8 leading-relaxed whitespace-pre-line">
                  {slide.subtitle}
                </p>
                <button className="solox-btn bg-[#0B2A2C] text-white hover:text-[#0B2A2C] border-2 border-[#0B2A2C] px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-all duration-300 w-full sm:w-auto relative overflow-hidden text-center">
                  <span>{slide.buttonText}</span>
                </button>
              </div>

              {/* Hero Images */}
              <div className="flex-1 max-w-2xl w-full z-20 order-1 md:order-2 pb-4 sm:pb-0">
                {slide.type === 'composite' ? (
                  <div className="flex flex-col gap-4 sm:gap-6">
                    <div className="w-full h-48 sm:h-56 md:h-64 lg:h-80 rounded-2xl overflow-hidden shadow-lg">
                      <img
                        src={slide.largeImage}
                        alt="Main therapy room"
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                      />
                    </div>
                    <div className="flex gap-4 sm:gap-6">
                      <div className="flex-1 h-32 sm:h-40 md:h-48 rounded-xl overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105">
                        <img src={slide.smallImageLeft} alt="Therapy detail" className="w-full h-full object-cover" />
                      </div>
                      <div className="flex-1 h-32 sm:h-40 md:h-48 rounded-xl overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105">
                        <img src={slide.smallImageRight} alt="Therapy environment" className="w-full h-full object-cover" />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full h-54 sm:h-80 md:h-60 md:w-90 xs:h-90 lg:h-[500px] overflow-hidden rounded-3xl">
                    <img
                      src={slide.image}
                      alt={slide.title}
                      className="w-full h-full object-cover object-center transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                )}
              </div>

              {/* Original per-slide leaves (using leaf1 – completely untouched) */}
              {slide.leaves.map((leaf, leafIndex) => (
                <div
                  key={leafIndex}
                  className={`absolute z-10 pointer-events-none transition-opacity duration-1000 ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                  style={leaf.style}
                >
                  <img src={leaf.src} alt="Decorative leaf" className="w-full h-auto" />
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Slide Indicators */}
        <div className="hidden md:flex justify-start mt-0 md:mt-0 space-x-2 sm:space-x-3 z-30 relative">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'bg-[#0B2A2C] w-6 sm:w-8' : 'bg-[#0B2A2C]/50 hover:bg-[#0B2A2C]'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={goToPrevSlide}
          className="hidden md:block absolute -left-12 lg:-left-16 top-1/2 transform -translate-y-1/2 z-30 bg-white/80 hover:bg-white text-[#0B2A2C] w-10 h-10 sm:w-12 sm:h-12 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center"
          aria-label="Previous slide"
        >
          <span className="text-xl sm:text-2xl">‹</span>
        </button>
        <button
          onClick={goToNextSlide}
          className="hidden md:block absolute -right-12 lg:-right-16 top-1/2 transform -translate-y-1/2 z-30 bg-white/80 hover:bg-white text-[#0B2A2C] w-10 h-10 sm:w-12 sm:h-12 rounded-full shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center"
          aria-label="Next slide"
        >
          <span className="text-xl sm:text-2xl">›</span>
        </button>
      </div>

      {/* Gentle realistic floating animation for the new top-left leaf */}
      <style jsx>{`
        @keyframes float-gentle {
          0%, 100%   { transform: translateY(0) translateX(0) rotate(-25deg); }
          30%        { transform: translateY(-10px) translateX(6px) rotate(-23deg); }
          60%        { transform: translateY(8px) translateX(-4px) rotate(-27deg); }
          90%        { transform: translateY(-6px) translateX(3px) rotate(-24deg); }
        }
        .animate-float-gentle {
          animation: float-gentle 16s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;